import { getGlobalOutfitterIdQueryParam } from "~utils/helpers/url-param-helpers"
import useMinimalOutfitter from "~utils/hooks/use-minimal-outfitter"

export function useGlobalOutfitterFromParam() {
    const outfitterIdFromQueryParam = getGlobalOutfitterIdQueryParam()

    const { outfitter, isLoading, error } = useMinimalOutfitter({
        id: outfitterIdFromQueryParam,
    })

    return { outfitterFromQueryParam: outfitter, isLoading, error }
}
